"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasConstructorInClassHierarchy = void 0;
const _ = require("lodash");
const HasConstructorInClassHierarchy = (err, constructorName) => {
    let obj = err;
    let depth = 0;
    while (obj != null && depth < 10) {
        const constr = _.get(obj, ["constructor", "name"]);
        if (constr === constructorName) {
            return true;
        }
        obj = obj.__proto__;
        depth += 1;
    }
    return false;
};
exports.HasConstructorInClassHierarchy = HasConstructorInClassHierarchy;
//# sourceMappingURL=LogsUtils.js.map